import React, {  } from "react";
import type * as controls from "../PhoenixFormsV4.Controls";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import PNXLabel from "./PNXLabel";

interface ReadOnlyProps {
  controlProps: controls.SelectGroupItem;
}

interface Props extends ReadOnlyProps {
  updateValue: (newValue: string) => void;
  parentOnBlur: () => void;
};

const PhoenixSelectGroupItem = ({
  controlProps,
  updateValue,
  parentOnBlur,
} : Props) => {

  const id = `selectgroupitem-${controlProps.id}`;

  return <div>
    <FormControlLabel
      control={
        <Checkbox
          checked={controlProps.optionValue === controlProps.value}
          onChange={(e) => updateValue(e.target.checked ? controlProps.optionValue : "")}
          onBlur={parentOnBlur}
        />
      }
      label={<PNXLabel helpTopicId={controlProps.topicId}>{controlProps.label}</PNXLabel>}
    />
  </div>;
};

export const PhoenixSelectGroupItemReadOnly = ({
  controlProps,
} : ReadOnlyProps) => {
  //return <PNXLabel>{controlProps.label}</PNXLabel>;

  const id = `readonlyselectgroupitem-${controlProps.id}`;
  
  return <div>
    <FormControlLabel
      className="readonly-selectgroupitem"
      control={
        <Checkbox
          checked={controlProps.optionValue === controlProps.value}
          disabled
        />
      }
      label={<PNXLabel>{controlProps.label}</PNXLabel>}
    />
  </div>;
};

export default PhoenixSelectGroupItem;